import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';
import { z } from 'zod';

// The path and `code` search param are the link emailed to the LGO partner
// (Trades::Konnect::Pms::SendPartnerActivationRequestEmailJob).
export const pmsActivationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/pms_activation',
  validateSearch: z.object({
    code: z.preprocess((v) => (v === undefined ? undefined : `${v}`), z.string()),
  }),
}).lazy(() => import('pages/shared/PmsActivationPage/PmsActivationPage').then((d) => d.Route));
